import * as React from 'react';
import { Loader2 } from 'lucide-react';

export default function SkeletonL() {
  return (
    <div className="flex items-center justify-center h-screen w-full bg-gray-50/50">
      <Loader2 className="w-10 h-10 animate-spin text-blue-600" />
    </div>
  );
}